import { createSelector } from '@reduxjs/toolkit';

import filtersParametersSelector from '@/features/filters/selectors/parameters';

import { filtersApi } from '../reducer';

import filtersSelector from './filters';

/**
 * Получить результат запроса на получение всех фильтров
 */
const filtersDataSelector = createSelector(
  [filtersSelector, filtersParametersSelector],
  (filters, parameters) => {
    return filtersApi.endpoints.getFilters.select(parameters)({
      filters,
    });
  },
);

export default filtersDataSelector;
